// extracted by mini-css-extract-plugin
export default {"cta":"Cta_cta__+4h-Y","content":"Cta_content__BbX7B"};